import { ReactNode, FC } from 'react'
import CssBaseline from '@mui/material/CssBaseline'
import { ThemeProvider } from '@mui/material/styles'
import { billingThemeLight } from './theme'

type Props = {
    children: ReactNode
}

export const ThemeSwitcher: FC<Props> = ({ children }) => {
    return (
        <ThemeProvider theme={billingThemeLight}>
            <CssBaseline />
            {children}
        </ThemeProvider>
    )
}
